import StoreState from '../storeState';

export const sidebarMinimizedSelector = (state: StoreState) => state.layout.sidebarMinimized;
export const menuItemOpenedSelector = (state: StoreState) => state.layout.menuItemOpened;